import close from "../../../assets/images/close.svg"

import { Modal } from "react-bootstrap";
import { useAuth } from "../../../context/auth-user";

export default function AddStaff(props) {
	// VARIABLES RECIEVED FROM PROPS
	const { showAddModal, onHide, massiveStaffUpload, handleManuallyAddMember } = props

	const { user } = useAuth()
    const darkLightMode = user?.selectedProfile?.darkLightMode

	return (
		<Modal
			className={`addStaffModal ${darkLightMode ? "darkMode" : ""}`}
			show={showAddModal}
			onHide={onHide}
			size="lg"
			centered>
			<Modal.Body>
				<img className="closeModal" src={close} onClick={() => onHide()} alt="Prodensa Supplier" />

				<h4 className="title">Add members</h4>
				<p className="description">
					Please select a file to add a new member
				</p>

				<div className="inputSelection">
					<div className="inputContainer">
						<span className="label">Massive Excel</span>
						<input type="file" accept=".xlsx,.xls" onChange={(e) => massiveStaffUpload(e)} />
					</div>

					<h5 className="separator">OR</h5>

					<button 
						className="btnBgBlueTextGradient" 
						style={{ overflow: "hidden", textOverflow: "ellipsis", textWrap: "nowrap" }}
						onClick={handleManuallyAddMember}
					>
						Add Staff Manually
					</button>
				</div>
				<button className="btnBgWhiteTextBlack" onClick={() => onHide()}>Cancel</button>
			</Modal.Body>
		</Modal>
	)
}